import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../../hooks";
import ContestFormField from "../ContestFormField";
import {
  MAP_RESUBMISSION_REASON,
  OTHER_RESUBMISSION_CHARACTER_MAX
} from "../constants";
import ErrorField from "./ErrorField";

const ResubmissionField = ({ form, disableForm, onFormChange }) => {
  const { trans } = useTrans();

  const title = trans("Resubmission");

  const subtitle = (
    <div className="subtitle">
      {trans(
        "If you’ve submitted this STORY to the Watty Awards before, what inspired you to enter it again this year?"
      )}
    </div>
  );

  const resubmissionOtherErrorMessage = trans(
    "This field has to contain less than %s characters.",
    OTHER_RESUBMISSION_CHARACTER_MAX
  );

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <select
        id="resubmission-select"
        value={form.resubmission}
        name="resubmission"
        disabled={disableForm}
        className={"form-element"}
        onChange={onFormChange}
        aria-label={trans("Select an option")}
      >
        <option value="">{trans("Select an option")}</option>
        {MAP_RESUBMISSION_REASON(trans).map(reason => (
          <option key={reason.key} value={reason.key}>
            {reason.value}
          </option>
        ))}
      </select>
      {form.resubmission === "OTHER" && (
        <>
          <textarea
            className="form-element"
            id="other-resubmission-textarea"
            name="resubmissionOther"
            value={form.resubmissionOther}
            placeholder={trans("You can add more details here")}
            disabled={disableForm}
            onChange={onFormChange}
          />
          <ErrorField
            fieldId={"resubmission-other"}
            errorCondition={form.resubmissionOther === ""}
          />
          {form.resubmissionOther?.length >
            OTHER_RESUBMISSION_CHARACTER_MAX && (
            <ErrorField
              fieldId={"resubmission-other"}
              errorMessage={resubmissionOtherErrorMessage}
            />
          )}
        </>
      )}
    </ContestFormField>
  );
};

ResubmissionField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired
};

export default ResubmissionField;
